import { render, staticRenderFns } from "./CRMCustomerLog.vue?vue&type=template&id=0a3edf9d&scoped=true&"
import script from "./CRMCustomerLog.vue?vue&type=script&lang=js&"
export * from "./CRMCustomerLog.vue?vue&type=script&lang=js&"
import style0 from "./CRMCustomerLog.vue?vue&type=style&index=0&id=0a3edf9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3edf9d",
  null
  
)

export default component.exports